import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Profile ke child pages (basic info, work, referral) save ke baad ping() karte hain,
 * taake shell ka "Profile Completion" card turant update ho jaye.
 */
@Injectable({ providedIn: 'root' })
export class ProfileRefreshService {
  private subject = new Subject<void>();
  changes$ = this.subject.asObservable();

  ping() {
    this.subject.next();
  }
}
